import {
  Box,
  Divider,
  IconButton,
  Paper,
  TablePagination,
  Typography,
  debounce,
} from "@mui/material";
import {
  FilterPannel,
  SettingPageMainBoxTitle,
} from "../../Customization/CommonElements";
import {
  AnalyticsBoxWrapper,
  BroadcastDetailListWrapper,
  ErrorComponent,
  LeftCol,
  MainContainer,
  NewNativeSelect,
  RightCol,
  TemplateTable,
  TopBar,
  WrapperContainer,
} from "./Styles";
import { BroadCastTitleBar } from "../../Components/Broadcast/Utils/CommomBroadcastStyle";
import { useNavigate, useParams } from "react-router-dom";
import { AppMaterialIcons } from "../AppMaterialIcons";
import { useEffect, useState } from "react";
import { marketingListActions } from "../../Store/Slices/MarketingList/marketingList.actions";
import { useAppDispatch } from "../../Store";
import { useNotification } from "../../Hooks/useNotification/useNotification";
import {
  renderAnalyticsData,
  renderSkeleton,
} from "../../Components/Broadcast/WhatsApp/Utils/utils";
import AppForm from "./AppForm";
import AppFormSearchField from "./AppFormSearchField";
import AppButton from "../AppButton";
import { AppToolTip } from "../../Components/UiComponents/AppToolTip/AppToolTip";
import { uniqueId } from "lodash";
import TemplateAPIERROR from "../../assets/images/No_records _found.svg";
import { ChatbotConsoleService } from "../../Services/Apis/ChatbotConsoleService";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { CoreService } from "../../Services/Apis/CoreApis";
import _ from "lodash";
import EmailDashboardOverview from "../../Components/Broadcast_Dashboard/Email_Broadcast_Overview/Email_broadcast";
import moment from "moment";
import { broadcastActions } from "../../Store/Slices/BroadcastDashboard/BroadcastDash.actions";
import { emailDetailsLayouts } from "../../Components/Broadcast/Utils/utils";

import { WrapRecipients } from "../../Components/Broadcast_Dashboard/Email_Broadcast_Overview/Emai_broadcastStyles";
import NoRecordsFound from "../../Components/UiComponents/NoRecordsFound/NoRecordsFound";
import ResponsiveTable from "../../Components/Broadcast/SMS/SMS_Dashboard/SMS_dashboard_byId/SMS_Dashboard_Logs/ResponsiveTable";
import BroadcastTopInfoBar from "../../Components/Broadcast/components/BroadcastTopInfoBar";
import { useSelector } from "react-redux";
import { broadcastDataById, broadcastType } from "../../Store/Slices/BroadcastDashboard/Broadcast.selectors";
import AppPaginationComponent from "../Pagination/Pagination";
import { theme } from "../../Customization/Theme";
import SkeletonLoader from "../Loader/SkeletonLoader";






const BroadcastHistory = (props: any) => {
  const navigate = useNavigate();
  const broadcast_id = useParams();
  const dispatch = useAppDispatch();
  let { showAlert } = useNotification();
  const [user, setUser] = useState<any>([]);
  const [fieldMapping, setFieldMapping] = useState<any>([]);
  const [fieldMappingKey, setFieldMappingKey] = useState<any>([]);
  const [getBroadcastData, setBroadcastData] = useState(false);
  const [onSearch, setOnSearch] = useState(false);
  const [showSkeleton, setShowSkeleton] = useState(false);
  const [errorApi, setErrorApi] = useState(false);
  const [totalcount, setTotolCount] = useState(0);
  const [credits, setCredits] = useState<any>([]);
  const [analyticsName, setAnalyticsName] = useState<string>("");
  const [statsData, setStatsData] = useState<any>([]);
  const [headerKeys, setHeaderKeys] = useState<any[]>([]);
  const [pagination, setPagination] = useState<any>();
  const [resultList, setResultList] = useState([]);
  const [tableValue, setTableValue] = useState<any>({});
  const [loading, setLoading] = useState(false);
  
  const broadcastTypeData = useSelector(broadcastType);
  const broadcastDataByIdData = useSelector(broadcastDataById);

  const BroadcastByIdDataList = broadcastDataByIdData?.results;

  // const [localValues, setLocalValues] = useState<any>({
  //   itemsPerPage: 10,
  //   currentPage: 0,
  //   search: "",
  // });

  const [localValues, setLocalValues] = useState<any>({
    // itemsPerPage: 10,
    itemsPerPage: { label: "50  per page", value: 50 },
    currentPage: 0,
    status: "",
    search: "",
    id: broadcast_id?.broadcast_id,
  });

  // const getBroadCastDetailedData = () => {
  //   setShowSkeleton(true)
  //   const payload = {
  //     limit: localValues.itemsPerPage,
  //     offset: onSearch ? 0 : localValues.currentPage,
  //     status: localValues?.status,
  //     search: localValues?.search,
  //     id: broadcast_id.broadcast_id,

  //   };
  //   dispatch(marketingListActions.getBroadcastByID(payload))
  //     .then((res: any) => {
  //       var result = Object.keys(res?.payload?.data?.field_mapping).map((key) => [res?.payload?.data?.field_mapping[key]]);
  //       var fieldMappingKey = Object.keys(res?.payload?.data?.field_mapping).map((key) => [key]);
  //       setUser(res?.payload?.data.results);
  //       setFieldMapping(result || props?.header)
  //       setFieldMappingKey(fieldMappingKey || props?.header)
  //       setTotolCount(res?.payload?.data?.count);
  //       setAnalyticsName(res?.payload?.data?.broadcast_name);
  //       setShowSkeleton(false)
  //       setOnSearch(false)
  //       setErrorApi(false);
  //       setBroadcastData(false)
  //     })
  //     .catch((error: any) => {
  //       setErrorApi(true);
  //       showAlert(
  //         error?.response?.statusText || "Unable to fetch data",
  //         "error"
  //       );
  //       setShowSkeleton(false)
  //       setOnSearch(false)
  //       setBroadcastData(false)
  //     })
  //     .finally(() => {
  //     });
  // }
  // useEffect(() => {
  //   if (getBroadcastData) {
  //     getBroadCastDetailedData();
  //     setBroadcastData(false)
  //   }
  // }, [getBroadcastData]);
  // useEffect(() => {
  //   getBroadCastDetailedData();
  // }, []);

  // function handlePageChange(event: any, value: any) {
  //   event.stopPropagation();
  //   setLocalValues({
  //     ...localValues,
  //     currentPage: parseInt(value),
  //   });
  //   setBroadcastData(true)
  // }
  // const handleChangeRowsPerPage = (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   event.stopPropagation();
  //   setLocalValues({
  //     ...localValues,
  //     itemsPerPage: parseInt(event.target.value, 10),
  //     currentPage: 0,
  //   });
  //   setBroadcastData(true)
  // };

  // const handleSelectSearch = debounce((e?: any, field?: any) => {
  //   setLocalValues({
  //     ...localValues,
  //     [field]: e,
  //     currentPage: 0,
  //   });
  //   setOnSearch(true)
  //   setBroadcastData(true)
  // }, 700);
  // const clearCallback = (e?: any, field?: any) => {
  //   setLocalValues({
  //     ...localValues,
  //     [field]: "",
  //   });
  //   setBroadcastData(true)
  // };

  // const handleClick = () => {
  //   const id = broadcast_id.broadcast_id;
  //   ChatbotConsoleService.getWhatsappBroadcastDetailsDownload(`${id}`)
  //     .then(response => {
  //       window.open(response.data.data.source, '_blank');
  //     })
  //     .catch(error => {
  //       console.error('Error occurred while fetching the file URL.', error);
  //     });
  // }

  const handleNavigate = () => {
    navigate(`/broadcast/${props.broadcastType}/history`, { replace: true });
  };

  useEffect(() => {
    CoreService.getCredits().then((response) => {
      const reversedItems = response?.data;
      setCredits(reversedItems);
      props?.getCreditsData(reversedItems);
    });
  }, []);

  // Headers For Table
  const header = [
    "Primary Email",
    "First Name",
    "Last Name",
    "Message Status",
    "Mobile",
  ];
  // Mapping For Table Column
  const keyToHeaderMap: any = {
    "Primary Email": "email",
    "First Name": "first_name",
    "Last Name": "last_name",
    "Message Status": "message_status",
    Mobile: "mobile",
  };
  // Width For Table Column
  const colWidth: any = {
    "Primary Email": "320",
    "First Name": "220",
    "Last Name": "220",
    "Message Status": "200",
    Mobile: "300",
  };
  const formatDateField = (dateObj: any) => {
    const date = moment(dateObj).format(" DD MMM , YYYY hh:mm A ");
    // const date = moment(dateObj).format("DD MMM, YYYY HH:mm A");
    return date;
  };


  function handlePageChange(event: any, value: any) {
    setLocalValues({
      ...localValues,
      currentPage: value - 1,
    });
  }
  const handleChangeRowsPerPage = (value: any) => {
    setLocalValues({
      ...localValues,
      itemsPerPage: value,
      currentPage: 0,
    });
  };


  const getBroadCastDetailedData = () => {
    setLoading(true);
    const payload = {
      limit: localValues?.itemsPerPage?.value,
      offset: onSearch ? 0 : localValues?.currentPage,
      status: localValues?.status,
      search: localValues?.search,
      id: broadcast_id?.broadcast_id,
    };
    dispatch(broadcastActions.getBroadcastByID(payload))
      .then((res: any) => {
        setPagination(res?.payload?.data?.pagination);
        setResultList(res?.payload?.data?.results);
        setHeaderKeys(res?.payload?.data?.columns_mapping);
        setTableValue(res?.payload?.data?.field_mapping);
      })
      .catch((error: any) => {
        showAlert(
          error?.response?.statusText || "Unable to fetch data",
          "error"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const getStatsData = () => {
  //   // setLoading(true);
  //   dispatch(broadcastActions.getBroadcastStatsData(broadcast_id?.broadcast_id))
  //     .then((res: any) => {
  //       setStatsData(res?.payload?.data?.broadcast_details);
  //       // setStatsData(res?.payload?.data?.broadcast_stats);
  //       // setDeliverabilityRate(
  //       //   res?.payload?.data?.broadcast_stats?.deliverability_rate || 0
  //       // );
  //       // setClickRate(res?.payload?.data?.broadcast_stats?.click_rate || 0);
  //       // setOpenRate(res?.payload?.data?.broadcast_stats?.open_rate);
  //       // setBroadcastDetails(res?.payload?.data?.broadcast_details);
  //       // setTopLink(res?.payload?.data?.link_stats);
  //       // setDeviceInfo(res?.payload?.data?.device_info);
  //       // setDeviceTablelength(res?.payload?.data?.device_info.length);
  //       // setLoading(false);
  //     })
  //     .catch((error: any) => {
  //       showAlert(
  //         error?.response?.statusText || "Unable to fetch data",
  //         "error"
  //       );
  //       // setLoading(false);
  //     })
  //     .finally(() => {
  //       // setLoading(false);
  //     });
  // };

  useEffect(() => {
    // getStatsData();
    getBroadCastDetailedData()
  }, [localValues]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainContainer style={{ padding: 0, marginTop: "2px" }}>


      <BroadcastTopInfoBar
        title={broadcastTypeData?.broadcast_name || broadcastDataByIdData?.broadcast_name}
        date={broadcastTypeData?.broadcast_details?.sent_on || broadcastDataByIdData?.sent_on}
      type="whatsapp" 
      />
      {/* <BroadCastTitleBar style={{ backgroundColor: "#fff" }}>
        <div className="left">
          <IconButton onClick={handleNavigate}>
            <AppMaterialIcons iconName="ArrowBackIosOutlined" />
          </IconButton>
          <p>
            {analyticsName && analyticsName.length
              ? analyticsName
              : props?.headerTitle}
          </p>
        </div>
        <div className="right"></div>
      </BroadCastTitleBar> */}

  <Box p={2}>
        {
        loading ? (
            <Box sx={{
              height: "calc(100vh - 237px)",
              backgroundColor: `${theme.palette.default.white}`,
            }}>
              <SkeletonLoader numberOfCol={4} numberofRow={6} />
            </Box>
          ) : BroadcastByIdDataList?.length ? (
            <>
                <ResponsiveTable
                columns={headerKeys}
                data={resultList}
                rowsPerPage={localValues?.itemsPerPage}
                pageNumber={localValues?.currentPage}
                totalDataCount={totalcount}
                hasMoreData={true}
                name={"formkey4"}
                setCheckboxFieldValue={"setFieldValue"}
                subscriptionName={"subscriptionName"}
                tableValue={tableValue}
                />

                {
                  BroadcastByIdDataList?.length ? (
                    <AppPaginationComponent
                      totalCount={pagination?.totalRecords}
                      handlePageChange={handlePageChange}
                      currentPage={localValues?.currentPage}
                      totalPages={pagination?.totalPages}
                      rowsPerPage={localValues?.itemsPerPage}
                      handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                  ) : null
                }
            </>
          ) : (
            <NoRecordsFound height="calc(100vh - 240px);" />
            )
          }
        </Box>
      {/* <EmailDashboardOverview domElements={[]} preventCollision={false}/> */}
      {/* <AnalyticsBoxWrapper>
          {
            renderAnalyticsData(props?.data)
          }
        </AnalyticsBoxWrapper> */}
      {/* <BroadcastDetailListWrapper>
          <FilterPannel>
            <div className="detailSMStableAction-wrapepr">
              <Box>
                <div>
                  Total Contacts: <strong> {totalcount}</strong>
                </div>
              </Box>
              <Box>
                <AppForm
                  initialValues={{ search: "" }}
                  onSubmit={(values: any, submitProps: any) => {}}
                  divStyle={{ width: "100%", paddingLeft: "10px" }}
                >
                  <div className="detailSMStableAction">
                    <AppFormSearchField
                      name="search"
                      placeholder="Search"
                      defaultBorder={true}
                      divStyle={{
                        marginBottom: "0px",
                        minWidth: "280px",
                        maxWidth: "280px",
                      }}
                      onChange={(e: any) => {
                        handleSelectSearch(e, "search");
                      }}
                      clearCallback={(e: any) => clearCallback(e, "search")}
                    />
                    <div className="right">
                      <AppButton
                        divStyle={{ minWidth: "120px" }}
                        onClick={handleClick}
                        download
                      >
                        Export To CSV
                      </AppButton>
                    </div>
                  </div>
                </AppForm>
              </Box>
            </div>
          </FilterPannel>

          <TableWrapper height={props.height}>
            <div>
              <Box className="table-header">
                <Box className="table-row">
                  {header?.map((header: string, index: number) => {
                    return (
                      <Box
                        className={`col-head ${header
                          .toLowerCase()
                          .replaceAll(" ", "_")}`}
                        style={{
                          // maxWidth: colWidth[header] + "px",
                          minWidth: colWidth[header] + "px",
                        }}
                      >
                        <Typography sx={{ fontWeight: 500 }}>
                          {header}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
              <Box className="table-body">
                {errorApi || user?.length === 0 ? (
                  <>
                    {showSkeleton ? (
                      renderSkeleton()
                    ) : (
                      <ErrorComponent style={{ gap: 0, marginTop: "2rem" }}>
                        <Box display="flex" justifyContent="center">
                          <img width="300" src={TemplateAPIERROR} alt="" />
                        </Box>
                        <Box className="error-Info">
                          <Typography variant="h6" fontSize="20px">
                            No Records Found
                          </Typography>
                        </Box>
                      </ErrorComponent>
                    )}
                  </>
                ) : (
                  <>
                    {user?.map((row: any, rowIndex: any) => {
                      return (
                        <Box key={rowIndex} className="table-row">
                          {header?.map((header: any, ColumnIndex: any) => {
                            const isActionColumn = header === "Action";
                            return (
                              <Box
                                className={`col-body ${header
                                  .toLowerCase()
                                  .replaceAll(" ", "_")}`}
                                title={
                                  header === "Scheduled"
                                    ? formatDateField(
                                        row[keyToHeaderMap[header]]
                                      )
                                    : row[keyToHeaderMap[header]]
                                    ? row[keyToHeaderMap[header]]
                                    : "-"
                                }
                                style={{
                                  // maxWidth: isActionColumn
                                  //   ? "400px"
                                  //   : colWidth[header] + "px",
                                  minWidth: isActionColumn
                                    ? "400px"
                                    : colWidth[header] + "px",
                                }}
                              >
                                <Typography className="table-text">
                                  {header === "Scheduled"
                                    ? formatDateField(
                                        row[keyToHeaderMap[header]]
                                      )
                                    : row[keyToHeaderMap[header]]
                                    ? row[keyToHeaderMap[header]]
                                    : "-"}
                                </Typography>
                              </Box>
                            );
                          })}
                        </Box>
                      );
                    })}
                  </>
                )}
              </Box>
            </Paper>
          </TemplateTable>
          {user?.length ? (<TablePagination
            component="div"
            className="table-pagination"
            rowsPerPageOptions={[10, 25, 50]}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleChangeRowsPerPage}
            page={localValues?.currentPage}
            count={totalcount}
            rowsPerPage={localValues?.itemsPerPage}
          />) : null}
        </BroadcastDetailListWrapper> */}
    </MainContainer>
  );
};

export default BroadcastHistory;
